<template>
  <Modal
    :width="480"
    name="HAUSEFUL_INVOICE_DELETE_MODAL"
    :title="$t('hausefulInvoices.modals.exclude.title')"
    actions
  >
    <template v-slot:body>
      <h3 class="red--text">Esta é uma ação sem volta.</h3>
      <v-card class="py-4 px-4 my-3" color="grey lighten-3" outlined>
        <h6 class="text-uppercase grey--text">
          {{ $t('hausefulInvoices.realEstate') }}
        </h6>
        <span v-if="hausefulInvoiceInfo.real_estate" class="body-2">
          {{ hausefulInvoiceInfo.real_estate.name }}
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        class="grey--text"
        elevation="0"
        text
      >
        {{ $t('hausefulInvoices.modals.defaultActions.cancel') }}
      </v-btn>
      <v-btn
        @click="excludeInvoice"
        :loading="isLoading"
        elevation="0"
        class="ml-5"
        color="red"
        dark
      >
        {{ $t('hausefulInvoices.modals.exclude.action') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import Modal from '@/components/app/Modal'

export default {
  name: 'ModalHausefulTakeRateDelete',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['isLoading', 'hausefulInvoiceInfo']),
  },

  methods: {
    ...mapActions(['deleteHausefulTakeRateInvoice']),
    ...mapMutations(['closeAllModals']),

    excludeInvoice() {
      this.deleteHausefulTakeRateInvoice(this.hausefulInvoiceInfo.id)
    },
  },
}
</script>
